import Vue from "vue";
import VueRouter from "vue-router";
import { validarToken } from "../services/autenticacion";
import Modulos from "../services/modulos";
Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Login",
    component: () => import("../views/Login.vue"),
  },
  {
    path: "/nomina",
    name: "Principal",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/Principal.vue"),
    children: [
      {
        path: "reporte",
        name: "Recibos de Nómina",
        component: () => import("../views/Reporte.vue"),
      },
      {
        path: "archivo",
        name: "Subir recibos",
        component: () => import("../views/SubirRecibos.vue"),
      },
    ],
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

router.beforeEach(async (to, _from, next) => {
  if (to.name !== "Login" && !localStorage.getItem("jwt")) {
    next("/");
  } else if (to.name !== "Login") {
    const module = Modulos.find(
      (m) => to.fullPath.toLowerCase().indexOf(m.Router.toLowerCase()) > -1
    );
    if (!module) {
      next();
    } else {
      const permisos = JSON.parse(localStorage.getItem("modulos"));
      if (permisos.some((p) => p === module.ModuloID)) {
        next();
      } else {
        next("/");
      }
    }
  } else {
    next();
  }
});

export default router;
